import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import {styled} from "@mui/material/styles";
import PropTypes from "prop-types";
import {isMobile} from "react-device-detect";
import {useDispatch, useSelector} from "react-redux";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import CurrentImg from "../../../assets/img/proposal-img/current_circle.svg";
import {MdDone} from "react-icons/md";
import style from "../../../assets/css/proposal.module.scss";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {RxCross2} from "react-icons/rx";
import {useEffect} from "react";

const steps = [
  {label: "Business Details", index: 1},
  {label: "Past Experiences", index: 2},
  {label: "Premise Protection", index: 3},
  {label: "Safes and Vaults", index: 4},
  {label: "Exposure", index: 5},
  {label: "Stock Limits", index: 6},
  {label: "Shipping Limits & Exposure", index: 7},
  {label: "Memorandum & Entrustments", index: 8},
  {label: "Travel", index: 9},
  {label: "Exhibition", index: 10},
  {label: "Additional", index: 11},
  {label: "Trade References", index: 12},
];

// Custom styles
const StyledStepConnector = styled("div")(({theme}) => ({
  [`&.MuiStepConnector-root.MuiStepConnector-vertical`]: {
    width: "4px", // Increased width
    backgroundColor: theme.palette.primary.main, // Change color
    margin: "0 auto", // Center alignment
    borderRadius: "2px",
    minHeight: "30px", // Minimum height
  },
}));

// const StyledStepContent = styled(StepContent)(({theme}) => ({
//   // borderLeft: `4px solid ${theme.palette.primary.main}`, // Increased border width
//   marginLeft: theme.spacing(2), // Adjust margin
//   paddingLeft: theme.spacing(3), // Add padding for alignment
//   border: "none",
// }));

const ColorlibStepIconRoot = styled("div")(({theme}) => ({
  // backgroundColor: '#ccc',
  background: "#e0f5f4",
  border: "2px solid #004F71",
  zIndex: 1,
  color: "#fff",
  width: 32,
  height: 32,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(theme.palette.mode === "dark" && {
    backgroundColor: theme.palette.grey[700],
  }),
  "&.Mui-active": {
    background: "#004F71",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  "&.Mui-completed": {
    background: "#ffffff",
    svg: {color: "#004F71", fontSize: "22px"},
  },
  "&.invalidClass": {
    background: "#d32f2f",
    svg: {color: "#d32f2f", fontSize: "22px"},
    border: "2px solid #d32f2f",
  },
}));

function ColorlibStepIcon(props) {
  const {active, completed, className, ownerState} = props;
  // console.log("AHH", ownerState?.stepStatus, ownerState?.stepStatus?.status)
  // const icons = {
  //   1: <SettingsIcon />,
  //   2: <GroupAddIcon />,
  //   3: <VideoLabelIcon />,
  //   1: <SettingsIcon />,
  //   2: <GroupAddIcon />,
  //   3: <VideoLabelIcon />,
  //   1: <SettingsIcon />,
  //   2: <GroupAddIcon />,
  //   3: <VideoLabelIcon />,
  // };

  return (
    <ColorlibStepIconRoot
      className={`${className} ${ownerState?.stepStatus?.status === 2 ? "invalidClass" : ownerState?.stepStatus?.status === 0 && active ? "Mui-active" : ownerState?.stepStatus?.status === 1 ? "Mui-completed" : ""} `}
    >
      {ownerState?.stepStatus?.status === 2 ? (
        <RxCross2 color="#fff" />
      ) : ownerState?.stepStatus?.status === 1 ? (
        <MdDone />
      ) : ownerState?.stepStatus?.status === 0 && active ? (
        <img src={CurrentImg} alt="currentImg" />
      ) : (
        <>
          <span style={{color: "#004F71"}}> {String(props.icon)} </span>
        </>
      )}
      {/* {icons[String(props.icon)]} */}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
  proposalStep: PropTypes.number,
  stepStatus: PropTypes.object,
};

export default function VerticalStepper() {
  const dispatch = useDispatch();

  // const {user} = useSelector(selectAuthState);
  const {proposalStep, proposal_id, formValidations, clickedSteps} =
    useSelector(selectDataStoreState);

  // console.log("formValidations VerticalStepper ", formValidations);

  // const [activeStep, setActiveStep] = useState(0);
  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  // const handleReset = () => {
  //   setActiveStep(0);
  // };

  const handleStep = (currentStep) => {
    if (currentStep !== 1 && !proposal_id) {
      GlobalNotificationPopup({
        type: "info",
        message: "Please complete the Business Details step before proceeding.",
      });
      return;
    }
    dispatch(
      setDataStore({
        proposalStep: currentStep,
      })
    );
  };

  return (
    <Box>
      <div className="stepper_line">
        <Stepper
          activeStep={proposalStep - 1} //DEFAULT 1 STEP VALUE IS 0
          orientation={"vertical"}
          connector={<StyledStepConnector />}
        >
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                //style={{cursor: "pointer"}}
                onClick={() => handleStep(index + 1)}
                StepIconComponent={ColorlibStepIcon}
                stepStatus={formValidations[index]}
                stepData={step}
              >
                {/* {  console.log("clickedSteps",index, formValidations[index])} */}
                <h3 className={style.stepperh3}>{step.label}</h3>
              </StepLabel>
              {/* <StyledStepContent>
                <Box sx={{ mb: 2 }}>
                  {index !== 0 && (
                    <Button disabled={index === 0} onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                      Back
                    </Button>
                  )}
                  <Button variant="contained" onClick={handleNext} sx={{ mt: 1, mr: 1 }}>
                    SAVE
                  </Button>
                  <Button variant="contained" onClick={handleNext} sx={{ mt: 1, mr: 1 }}>
                    {index === steps.length - 1 ? 'Submit' : 'Next'}
                  </Button>
                </Box>
              </StyledStepContent> */}
            </Step>
          ))}
        </Stepper>
      </div>
      {/* {activeStep === steps.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you're finished</Typography>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )} */}
    </Box>
  );
}
